document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('nbpFabMain');
  const actions = document.getElementById('nbpFabActions');
  if (!btn) return;

  const fab = document.getElementById('nbpFab');
  const onScroll = () => fab.classList.toggle('nbp-fab--visible', window.scrollY > 300);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const footer = document.querySelector('footer, #shopify-section-footer-group, .footer');
  if (footer) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        fab.classList.toggle('nbp-fab--hidden', entry.isIntersecting);
      });
    }, { threshold: 0.1 });
    observer.observe(footer);
  }

  btn.addEventListener('click', function() {
    const isOpen = actions.classList.toggle('open');
    btn.classList.toggle('open', isOpen);
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('#nbpFab')) {
      actions.classList.remove('open');
      btn.classList.remove('open');
    }
  });
});